
import { mapGetters, mapState } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import Loading from "@/components/Loading";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

export default {
  name: "LayoutProspectLink",
  components: {
    KTAside,
    Loading,
  },
  beforeMount() {
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
    setTimeout(() => {
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);
  },
  methods: {},
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig", "isAuthenticated"]),
    ...mapState(["loading"]),
    contentFluid() {
      return "fluid";
    },
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    isLoading() {
      return this.loading.loading;
    },
  },
};
